export const upgradePlans = {
  month: "month",
  year: "year"
};

/**
 * The period an upgrade, renew or pending-payment option bills on.
 *
 * The APIs send it as `period` ("month", "year" or null for neither). A `period` key that is there wins, even as
 * null. Only an option from a backend that predates the field has no key, and its period is read from the `terms`
 * text (e.g. "$10.00 for each month") as before. Drop that fallback once the field is live everywhere.
 *
 * @param {{period?: "month"|"year"|null, terms?: string}|undefined|null} option
 * @returns {"month"|"year"|null} null when the plan bills on neither period
 */
export const getUpgradePlan = option => {
  const period = option?.period;
  if (period !== undefined) {
    return period === upgradePlans.year || period === upgradePlans.month ? period : null;
  }
  const terms = option?.terms;
  if (typeof terms !== "string") {
    return null;
  }
  if (terms.includes(upgradePlans.year)) {
    return upgradePlans.year;
  }
  if (terms.includes(upgradePlans.month)) {
    return upgradePlans.month;
  }
  return null;
};

/**
 * @param {Array<{period?: "month"|"year"|null, terms?: string}>} options
 * @param {"month"|"year"} plan
 */
export const findUpgradePlanOption = (options, plan) => options.find(option => getUpgradePlan(option) === plan);

/**
 * The option that starts out active when the options load: Monthly whatever order the API returned
 * them in, else Yearly, else the first option.
 *
 * @param {Array<{period?: "month"|"year"|null, terms?: string}>} options
 */
export const pickDefaultUpgradeOption = options => {
  if (!Array.isArray(options)) {
    return options?.[0];
  }
  return findUpgradePlanOption(options, upgradePlans.month) || findUpgradePlanOption(options, upgradePlans.year) || options[0];
};

/**
 * The option the coupon message is read from: Monthly first, else the first option. Kept from when the
 * modal sorted the options Monthly-first in place and read the message off the first one.
 *
 * @param {Array<{period?: "month"|"year"|null, terms?: string, coupon?: object}>} options
 */
export const pickCouponOption = options => findUpgradePlanOption(options, upgradePlans.month) || options[0];
